import React from "react";

import DisplayAd from "shared/components/DisplayAd";
import { FORMATS_KEYS } from "shared/modules/onpageads/constants";

import "./LeaderboardAd.scss";

const LeaderboardAd = React.forwardRef((_, ref) => (
	<div ref={ref} id="leaderboard_wrapper">
		<div id="leaderboard" className="leaderboard-leader">
			<div className="ad-container">
				<DisplayAd format={FORMATS_KEYS.LEADER} refresh />
			</div>
		</div>
	</div>
));

export default LeaderboardAd;



// WEBPACK FOOTER //
// ./src/routers/Desktop/HeaderBanner/LeaderboardAd.jsx